import React, { useRef, useEffect, useState } from 'react';
import {
    CSpinner,
    CButton,
    CRow,
    CCol,
    CCard,
    CCardBody,
    CCardHeader,
    CModal,
    CModalBody,
    CModalFooter,
    CModalHeader,
    CModalTitle,
    CBadge
  } from '@coreui/react'
import { useSelector, useDispatch } from 'react-redux';
import { SET_SHOW_INFOBOX, SET_VIEW_ADJUST,
        SET_POLL_MAP_YEAR, 
        SET_POLL_MAP_LOCAL_DIVISION,
        SET_MAP_COUNT,
        SET_POLL_MAP  } from '../../redux/actions';
import PartyStrengthControl from './PartyStrengthControl';
import maplibregl from 'maplibre-gl';
import './map.css';
import './maplibre-gl.css';
import { doReOrder, getSortedKeys, compare, provinceShortToLong, flCapital } from '../../helpers/Utils';
import ControlTranslated from './ControlTranslated';
import PSControl from './PSControl';
import ReactGA from 'react-ga';
import html2canvas from 'html2canvas';
import { CLOROTHEME } from '../../constants/defaultValues';
import history from '../../history'
import GoBroadControl from './GoBroadControl';
import GraphControl from './GraphControl'
import ScreenshotControl from './ScreenshotControl';

let fired = false;

const MapGL = (props) => {
    
    var dispatch = useDispatch();

    const darkMode = useSelector(state => state.starter.darkMode)
    const mapCount = useSelector(state => state.starter.mapCount)
    const showInfoBox = useSelector(state => state.starter.showInfoBox)
    const viewadjust = useSelector(state => state.starter.viewadjust)
    const federalYearDiv = useSelector(state => state.federalPollMap.yearDivision)
    const provincialYearDiv = useSelector(state => state.provincialPollMap.yearDivision)

    var politicalParties, leadershipRounds;
    var hoveredStateId = null;

    var mapObj = props.data;

    const mapContainer = useRef(null);
    const map = useRef(null);
    const [lng] = useState(props.data ? props.data.center[0] : -75.6972);
    const [lat] = useState(props.data ? props.data.center[1] : 45.4215);
    const [zoom] = useState(9);

    let [theParties, setTheParties] = useState([]);
    let [overlayLayer, setoverlayLayer] = useState({});
    const [screenWidth, setScreenWidth] = useState(window.innerWidth);
    let [theLeadershipRounds, setTheLeadershipRounds] = useState([]);
    let [theContent, setTheContent] = useState('');
    let [theRiding, setTheRiding] = useState([]);
    let [theScreenshot, setTheScreenshot] = useState(false);
    const [theMap, setTheMap] = useState(null);
    const [screenshotbuttondisable, setscreenshotbuttondisable] = useState(false);
    const [partyAdjustmentFactor, setPartyAdjustmentFactor] = useState([]);
    const [loading, setLoading] = useState(0);
    const mapContainerElement = useRef(null);
    const mapContainerRef = useRef(null);
    let [modalVisible, setModalVisible] = useState(false);
    let [modalContent, setModalContent] = useState('');
    let [pollDetailsTitle, setPollDetailsTitle] = useState('');
    let [mw, setMW] = useState('');
    let [thePollYear, setThePollYear] = useState('');
    let [theElectionType, setTheElectionType] = useState('');
    let [theRidingNumber, setTheRidingNumber] = useState('');
    let [theRejectedNumber, setTheRejectedNumber] = useState('');
    let [theElectorsNumber, setTheElectorsNumber] = useState('');
    let [partyStrengthSelected, setPartyStrengthSelected] = useState('Poll Winner');
    let [targetParty, setTargetParty] = useState('Conservative');
    let [cPVOrder, setCPVOrder] = useState([]);
    let [sortedParty, setSortedParty] = useState([]);
    let [candidateNameParty, setCandidateNameParty] = useState('');
    let [partyParty, setPartyParty] = useState('Poll Winner');
    let [mapLoad, setMapLoad] = useState(1);
    let [theGeoJSONUrl, setTheGeoJSONUrl] = useState('');
    let [isWholeMap, setIsWholeMap] = useState(false);
    let [isProvincialMap, setIsProvincialMap] = useState(false);
    let [theCandidates, setTheCandidates] = useState(false);
    let [graphDataObject, setGraphDataObject] = useState('');
    let [graphVisible, setGraphVisible] = useState(false);

    useEffect(() => {

            console.log(federalYearDiv)
          setPartyParty('Poll Winner')
          setPartyStrengthSelected('Poll Winner');

      }, [federalYearDiv, provincialYearDiv])
  

    const mapScreenshot = () => {
        ReactGA.event({
          category: "Map screenshot",
          action: "click",
          label: mapObj.geojson_url,
        });
        
        const elements = mapContainer.current;
        html2canvas(elements, {
            useCORS:true, 
            allowTaint:true
        }).then(canvas => {
          var pseudolink = document.createElement('a');
          pseudolink.download = mapObj.title+'.png';
          pseudolink.href = canvas.toDataURL()
          pseudolink.click();
          document.getElementById("mapScreenshotButton").removeAttribute("disabled");
          setTheScreenshot(false);
      }).catch(err => console.log(err) );
      }
  
      const sharetwitter = () => {
        var quote = "Check out the results of "+mapObj.district;
        quote = encodeURIComponent(quote);
        if (mapObj.event_type === "Provincial") {
          window.open("https://twitter.com/intent/tweet?url=https://www.stephentaylor.ca/data/political/canada/provincial/election/"+provinceShortToLong(mapObj.minor_jurisdiction).toLowerCase()+"/"+mapObj.year+"/"+mapObj.local_division+"/&text="+quote, "pop", "width=600, height=600, scrollbars=no");
        } else {
          window.open("https://twitter.com/intent/tweet?url=https://www.stephentaylor.ca/data/political/canada/federal/election/"+mapObj.year+"/"+mapObj.local_division+"/&text="+quote, "pop", "width=600, height=600, scrollbars=no");
        }
        return false;
      }
      
      const sharepinterest = () => {
        if (mapObj.event_type === "Provincial") {
          window.open("https://pinterest.com/pin/create/link/?url=https://www.stephentaylor.ca/data/political/canada/provincial/election/"+provinceShortToLong(mapObj.minor_jurisdiction).toLowerCase()+"/"+mapObj.year+"/"+mapObj.local_division+"/&media=https://geojson-maps.s3.amazonaws.com/images/"+mapObj.minor_jurisdiction+"-"+mapObj.year+"-"+mapObj.local_division+"-600.png&description="+mapObj.district, "pop", "width=600, height=600, scrollbars=no");
        } else {
          window.open("https://pinterest.com/pin/create/link/?url=https://www.stephentaylor.ca/data/political/canada/federal/election/"+mapObj.year+"/"+mapObj.local_division+"/&media=https://geojson-maps.s3.amazonaws.com/images/"+mapObj.year+"-"+mapObj.local_division+"-600.png&description="+mapObj.title, "pop", "width=600, height=600, scrollbars=no");
        }
      }
  
      document.addEventListener('keydown', function(event) {
        if (event.keyCode === 191) {
            setscreenshotbuttondisable(true);
            mapScreenshot();
          }
      });
  
      document.addEventListener('keyup', (e) => {
        fired = false;
      });

    const mouseMoveHighlight = (e) => {
        if (e.features.length > 0) {
            if (hoveredStateId) {
                map.current.setFeatureState(
                    { source: 'testmap-sn', id: hoveredStateId },
                    { hover: false }
                );
            }
            hoveredStateId = e.features[0].id;
            map.current.setFeatureState(
                { source: 'testmap-sn', id: hoveredStateId },
                { hover: true }
            );
            map.current.getCanvas().style.cursor = 'pointer'
        }
    }

    const mouseLeaveHighlight = () => {
        if (hoveredStateId) {
            map.current.setFeatureState(
                { source: 'testmap-sn', id: hoveredStateId },
                { hover: false }
            );
        }
        map.current.getCanvas().style.cursor = ''
        hoveredStateId = null;
    }

    const setRiding = (a,b,c) => {
        props.updateMap(c);
    }

    const mapGLToParentLink = () => {
        props.updateMap({year:mapObj.year, event_type:mapObj.event_type, event:mapObj.event, goBroad:true});
    }

    const doMapModal = (e) => {
        var feature = e.features[0];
        var modaldata = '';
        var tablearray = [];
        var candidateArray = [];
        var candidateDisplayArray = [];
        var pdt = '';
        var pollElectors = 0;
        var pollTotalVotes = 0;
        var ridingName = '';
        var pollName = '';
        var pollID = '';
        var pollWinner = '';
        var pollYear = '';
        var electionType = '';
        var ridingNumber = '';
        var rejectedNumber = '';
        var electorsNumber = '';
        var mergeWith = null;
        for (var key in feature.properties) {
            if (feature.properties.hasOwnProperty(key)) {
              // if (key === "Electors") {
              //   pollElectors = feature.properties[key];
              // }            
              if (key !== "Candidates") {
                if (key === "Riding Name") {
                  ridingName = feature.properties[key];
                } else if (key === "Poll name") {
                  pollName = feature.properties[key];
                } else if (key === "pr") {
                  // omit
                } else if (key === "Poll ID") {
                  pollID = feature.properties[key];
                } else if (key === "Rejected Ballots") {
                  rejectedNumber = feature.properties[key];                
                } else if (key === "Electors") {
                  electorsNumber = feature.properties[key];                                
                } else if (key === "Poll Winner") {
                  pollWinner = feature.properties[key];
                } else if (key === "Riding") {
                  ridingNumber = feature.properties[key];                
                } else if (key === "mw") {
                  mergeWith = feature.properties[key];
                } else if (key === "Election") {
                  pollYear = feature.properties[key];
                } else if (key === "Election Type") {
                  electionType = feature.properties[key];
                } else {
                  var tableObj = {};
                  tableObj.name = key;
                  tableObj.val = feature.properties[key]
                  tablearray.push(tableObj);
                }              //tabledata += '<tr><td style="padding:5px;border:1px solid black;">'+key+'</td><td style="padding:5px;border:1px solid black;">'+feature.properties[key]+'</td></tr>'
              }
            }
        }
        pdt = ridingName + ' ('+pollID+' - ' + pollName+')';
        for (var key1 in feature.properties) {
          if (feature.properties.hasOwnProperty(key1)) {
              if (key1 === "Candidates") {
                var candidateJSON = JSON.parse(feature.properties[key1]);
                for (var i=0;i<candidateJSON.length;i++) {
                  var countObj = {};
                  countObj.name = candidateJSON[i].name;
                  countObj.party = candidateJSON[i].party;
                  countObj.val = candidateJSON[i].votes;
                  pollTotalVotes += candidateJSON[i].votes;    
                  candidateArray.push(countObj);
                }
                for (i=0;i<candidateArray.length;i++) {
                  if (pollTotalVotes > 0) { 
                    candidateArray[i].pc = (candidateArray[i].val / pollTotalVotes * 100).toFixed(1);
                  } else {
                    candidateArray[i].pc = 0+"%";
                  }
                }
                candidateArray.sort(compare);
                for (i=0;i<candidateArray.length;i++) {                                  
                  var tableObj1 = {};
                  tableObj1.name = candidateArray[i].name + (pollWinner === candidateArray[i].party && i === 0 ? ' ⭐' : '');
                  tableObj1.party = candidateArray[i].party;
                  tableObj1.val = candidateArray[i].val;
                  tableObj1.pc = candidateArray[i].pc;
                  candidateDisplayArray.push(tableObj1);
                  //tabledata += '<tr><td style="padding:5px;border:1px solid black;">'+feature.properties[key][i].name+' ('+feature.properties[key][i].party+')</td><td style="padding:5px;border:1px solid black;">'+feature.properties[key][i].votes+' votes</td></tr>'  
                }
              }
          }
        }      

        dispatch({type: SET_SHOW_INFOBOX, showInfobox: false});
        var mc = [];
        var candidateRows = candidateDisplayArray.map((item,ind) => 
        <CRow key={ind} className="border">
          <CCol style={ind%2 ? {fontSize:'10px'} : {backgroundColor:'#eaeaea',fontSize:'10px'}}>{item.name}</CCol>
          <CCol xs style={ind%2 ? {fontSize:'10px'} : {backgroundColor:'#eaeaea',fontSize:'10px'}}>{item.party}</CCol>
          <CCol className="col-2" style={ind%2 ? {fontSize:'10px'} : {backgroundColor:'#eaeaea',fontSize:'10px'}}>{item.val}</CCol>
          <CCol className="col-2" style={ind%2 ? {fontSize:'10px'} : {backgroundColor:'#eaeaea',fontSize:'10px'}}>{item.pc}</CCol>
        </CRow>
        )
        var candidateTable = (<div key={"candidate-table"} style={{margin:'0 auto',position:'relative',width:'90%'}}>
          <CRow className="border">
            <CCol xs style={{fontWeight:'500',fontSize:'10px'}}>Candidate</CCol>
            <CCol xs style={{fontWeight:'500',fontSize:'10px'}}>Party</CCol>
            <CCol className="col-2" style={{fontWeight:'500',fontSize:'10px'}}>Votes</CCol>
            <CCol className="col-2" style={{fontWeight:'500',fontSize:'10px'}}>%</CCol>
          </CRow>
          {candidateRows}
          </div>)

        var pollTableData = (<div key={"poll-table"} style={{margin:'0 auto',position:'relative',width:'90%',paddingTop:'10px'}}>
        <CRow>
          { electorsNumber != null ? <CCol xs style={{fontSize:'10px'}}><span role="img" aria-label="electors emoji">👥</span> Electors: {electorsNumber}</CCol> : <></> }          
        </CRow>
        <CRow>
        { rejectedNumber != null ? <CCol xs style={{fontSize:'10px'}}><span role="img" aria-label="rejected emoji">🙅‍♀️</span> Rejected ballots: {rejectedNumber}</CCol> : <></> }
        </CRow>
        </div>
        )
      mc.push(candidateTable);
      mc.push(pollTableData);
      setPollDetailsTitle(pdt);
      setMW(mergeWith);
      setThePollYear(pollYear);
      setTheElectionType(electionType);
      setTheRidingNumber(ridingNumber);
      setModalContent(mc); 
      setModalVisible(true);             
        //console.log(e.features[0]);        
    }

    var firstSymbolId;

    useEffect(() => {
        setMapLoad(1);
        // if (map.current != null && props.data.geojson_url !== theGeoJSONUrl) {
        //     if (map.current.getLayer('sn-layer-poll-shapes')) {
        //         map.current.removeLayer('sn-layer-poll-shapes');
        //     }
        //     // if (map.current.getSource('testmap-sn')) {
        //     //     map.current.removeSource('testmap-sn');
        //     // }
        //     //setTheGeoJSONUrl(props.data.geojson_url);
        // }
        console.log(props.data)
        if (map.current == null) { //return; //stops map from intializing more than once
            map.current = new maplibregl.Map({
                container: mapContainer.current,
                style: 'https://geojson-maps.s3.amazonaws.com/style.json',
                center: [lng, lat],
                minPitch: 0,
                maxPitch: 60,
                pitchWithRotate: true,
                zoom: zoom,
                attributionControl: false,
                preserveDrawingBuffer: true
            });
            map.current.on('load', function(){
                map.current.addSource('fsa-source', {
                    type: 'geojson',
                    data: 'https://geojson-maps.s3.amazonaws.com/extra/fsa_bG3vNkFjJ2xgFmRw8TzA.geojson' // Replace with the URL or file path to your GeoJSON data
                });                
                document.addEventListener('keydown', (event) => {
                    if (event.ctrlKey && event.shiftKey && event.key === 'L') {
                      map.current.addLayer({
                        id: 'fsa-layer',
                        type: 'fill',
                        source: 'fsa-source',
                        paint: {
                          'fill-color': 'rgba(255,0,0,0.1)',
                          'fill-outline-color': '#f00'
                        }
                      });
                      map.current.addLayer({
                        id: 'fsa-line-layer',
                        type: 'line',
                        source: 'fsa-source',
                        paint: {
                          'line-color': '#f00',
                          'line-width': 2
                        }
                      });
                      map.current.addLayer({
                        id: 'my-layer',
                        type: 'symbol',
                        source: 'fsa-source',
                        layout: {
                          'text-field': ['get', 'CFSAUID'],
                          'text-font': ['Open Sans Regular'],
                          'text-size': 14,
                          'text-anchor': 'center',
                          'text-offset': [0, 0]
                        },
                        paint: {
                          'text-color': '#000000'
                        }
                      });                      
                      map.current.on('mousemove', 'fsa-layer', function (e) {
                        console.log(e.features[0].properties.CFSAUID);
                      });        
                    }
                  });
            })            
            map.current.addControl(new maplibregl.NavigationControl({
                visualizePitch: true,
                
            }),'top-left');    
            
            map.current.addControl(new maplibregl.AttributionControl({
                compact: false,
                customAttribution: "© <a href='https://stephentaylor.ca'>Stephen Taylor</a>; Style: <a href='https://openmaptiles.org/'>OpenMapTiles</a>; <a href='https://stephentaylor.ca/data-sources'>Data</a>; <a href='https://www.openstreetmap.org/copyright'>© OpenStreetMap contributors</a>"
            }));
            map.current.addControl(new maplibregl.FullscreenControl({container: document.querySelector('#mainmap')}), 'top-left');                
        }
        // if (map.current.getSource('testmap-sn')) {
        //     console.log("D")
        //     if (map.current.getLayer('sn-layer-poll-shapes')) {
        //         map.current.removeSource('testmap-sn');
        //         console.log("B")
        //     }
        // }
        map.current.once('load', (e) => {
            var layers = map.current.getStyle().layers;
            for (var i = 0; i < layers.length; i++) {
                if (layers[i].type === 'symbol') {
                    firstSymbolId = layers[i].id;
                    break;
                }
            }
        })

        map.current.once('idle', (e) => {
            maplibregl.clearStorage();
            var layers = map.current.getStyle().layers;
            for (var i = 0; i < layers.length; i++) {
                if (layers[i].type === 'symbol') {
                    firstSymbolId = layers[i].id;
                    break;
                }
            }            
            if ((props && props.data && props.data.minor_jurisdiction !== 'Canada' && props.data.event_type === 'Federal') || (props && props.data && props.data.map_context !== 'Provincial' && props.data.event_type === 'Provincial')) {
                setPartyStrengthSelected('Poll Winner');
                setPartyParty('Poll Winner');                
                setCandidateNameParty('');
                setIsWholeMap(false);           
            } else {
                setIsWholeMap(true);           
            }
            if (e.target.getSource('testmap-sn')) {
                if (e.target.getLayer('sn-layer-poll-shapes')) {
                    e.target.removeLayer('sn-layer-poll-shapes');                    
                }
                if (e.target.getLayer('sn-layer-poll-shapes-lines')) {
                    e.target.removeLayer('sn-layer-poll-shapes-lines');                    
                }
                if (e.target.getLayer('sn-layer-poll-shapes-lines-z0z13')) {
                    e.target.removeLayer('sn-layer-poll-shapes-lines-z0z13');                    
                }
                if (e.target.getLayer('sn-layer-riding-shapes')) {
                    e.target.removeLayer('sn-layer-riding-shapes');                    
                }
                if (e.target.getLayer('sn-layer-riding-shapes-lines')) {
                    e.target.removeLayer('sn-layer-riding-shapes-lines');                    
                }
                if (e.target.getLayer('sn-layer-riding-shapes-lines-z0z12')) {
                    e.target.removeLayer('sn-layer-riding-shapes-lines-z0z12');                    
                }                
                e.target.removeSource('testmap-sn');
                if (props.data) {
                    e.target.addSource('testmap-sn', {
                        type: 'geojson',
                        // Use a URL for the value for the `data` property.
                        data: props.data.geojson_url,
                        generateId: true
                    });
                } else {
                    e.target.addSource('testmap-sn', {
                        type: 'geojson',
                    });
                }
                // map.current.getSource('testmap-sn').setData({
                //     type: 'geojson',
                //     // Use a URL for the value for the `data` property.
                //     data: props.data.geojson_url,
                //     generateId: true
                // });                   
            } else {
                if (props.data) {
                    e.target.addSource('testmap-sn', {
                        type: 'geojson',
                        // Use a URL for the value for the `data` property.
                        data: props.data.geojson_url,
                        generateId: true
                    });
                } else {
                    e.target.addSource('testmap-sn', {
                        type: 'geojson',
                    });
                }
            } 
                if ((props && props.data && props.data.minor_jurisdiction !== 'Canada' && props.data.event_type === 'Federal') || (props && props.data && props.data.map_context !== 'Provincial' && props.data.event_type === 'Provincial')) {
                    e.target.addLayer({
                        'id': 'sn-layer-poll-shapes',
                        'type': 'fill',
                        'source': 'testmap-sn',
                        'maxzoom': 24,
                        'fill-antialias': false,
                        'filter': [
                            "any",
                            ["!=", "Poll Winner", "???"]
                        ],
                        'paint': {
                            'fill-color': [
                                'case',
                                ['all',partyStrengthSelected==='Poll Winner',['==', ['get', 'Poll Winner'],'Conservative']],
                                'rgba(9, 94, 230, 1)',
                                ['all',partyStrengthSelected==='Poll Winner',['==', ['get', 'Poll Winner'],'Progressive Conservative']],
                                'rgba(9, 94, 230, 1)',
                                ['all',partyStrengthSelected==='Poll Winner',['==', ['get', 'Poll Winner'],'United Conservative']],                                
                                'rgba(9, 94, 230, 1)',
                                ['all',partyStrengthSelected==='Poll Winner',['==', ['get', 'Poll Winner'],'Canadian Alliance']],
                                '#5ba963',
                                ['all',partyStrengthSelected==='Poll Winner',['==', ['get', 'Poll Winner'],'Alberta Party']],
                                '#f8c62e',
                                ['all',partyStrengthSelected==='Poll Winner',['==', ['get', 'Poll Winner'],'Wildrose']],
                                '#800080',                                                            
                                ['all',partyStrengthSelected==='Poll Winner',['==', ['get', 'Poll Winner'],'Alberta Independence']],
                                '#000000',                                
                                ['all',partyStrengthSelected==='Poll Winner',['==', ['get', 'Poll Winner'],'Liberal']],     
                                'rgba(230, 9, 9, 1)',
                                ['all',partyStrengthSelected==='Poll Winner',['==', ['get', 'Poll Winner'],'Ontario Party']],     
                                'rgba(11, 43, 82, 1)',
                                ['all',partyStrengthSelected==='Poll Winner',['==', ['get', 'Poll Winner'],'New Blue Party']],     
                                'rgba(23, 99, 247, 1)',
                                ['all',partyStrengthSelected==='Poll Winner',['==', ['get', 'Poll Winner'],'Ontario Liberal Party']],     
                                'rgba(230, 9, 9, 1)',                                
                                ['all',partyStrengthSelected==='Poll Winner',['==', ['get', 'Poll Winner'],'NDP-New Democratic Party']],
                                'rgba(230, 141, 9, 1)',
                                ['all',partyStrengthSelected==='Poll Winner',['==', ['get', 'Poll Winner'],'NDP']],
                                'rgba(230, 141, 9, 1)',
                                ['all',partyStrengthSelected==='Poll Winner',['==', ['get', 'Poll Winner'],'N.D.P.']],
                                'rgba(230, 141, 9, 1)',
                                ['all',partyStrengthSelected==='Poll Winner',['==', ['get', 'Poll Winner'],'Green Party']],
                                'rgba(0, 128, 0, 1)',
                                ['all',partyStrengthSelected==='Poll Winner',['==', ['get', 'Poll Winner'],'Green Party of Ontario']],
                                'rgba(0, 128, 0, 1)',
                                ['all',partyStrengthSelected==='Poll Winner',['==', ['get', 'Poll Winner'],'Ontario Green Party']],
                                'rgba(0, 128, 0, 1)',                                
                                ['all',partyStrengthSelected==='Poll Winner',['==', ['get', 'Poll Winner'],'Bloc Québécois']],
                                '#0b9fd6',                    
                                ['all',partyStrengthSelected==='Poll Winner',['==', ['get', 'Poll Winner'],"People's Party - PPC"]],
                                '#7f0f7e',
                                ['all',partyStrengthSelected==='Poll Winner',['==', ['get', 'Poll Winner'],"Communist"]],
                                '#c47373',                                                            
                                ['all',partyStrengthSelected==='Poll Winner',['==', ['get', 'Poll Winner'],"People's Party"]],
                                '#7f0f7e',
                                ['all',partyStrengthSelected==='Poll Winner',['==', ['get', 'Poll Winner'],"Communist"]],
                                '#c47373',                                
                                ['all',partyStrengthSelected==='Poll Winner',['==', ['get', 'Poll Winner'],"Independent"]],
                                '#424242',
                                ['all',partyStrengthSelected==='Poll Winner',['==', ['get', 'Poll Winner'],"null"]],
                                '#000000',
                                ['all',partyStrengthSelected!=='Poll Winner',['!=', ['get', 'Poll Winner'],"null"]],
                                ['rgb', 
                                ["-",255,
                                    ["*",
                                        ["*",
                                            ["/",['get', candidateNameParty+' votes'],['get', 'Poll total votes']],
                                        255],
                                        ["/",0.5,["/",['get', candidateNameParty+' riding total'],['get', 'Riding total votes']]]
                                    ]
                                ],
                                ["*",
                                    ["*",
                                        ["/",['get', candidateNameParty+' votes'],['get', 'Poll total votes']],
                                    255],
                                    ["/",0.5,["/",['get', candidateNameParty+' riding total'],['get', 'Riding total votes']]]
                                ]
                                ,0],
                                ['all',partyStrengthSelected==='Riding Winnery',['!=', ['get', 'Poll Winner'],"null"]],
                                ['rgb', 
                                ["-",255,
                                    ["*",
                                        ["*",
                                            ["/",['get', 'Poll total votes'],['get', 'Electors']],
                                        255],
                                    ]
                                ],
                                ["*",
                                    ["*",
                                        ["/",['get', 'Poll total votes'],['get', 'Electors']],
                                    255],
                                ]
                                ,0],
                                '#424242'
                                
                            ],
                            'fill-opacity': [
                                'case',
                                ['boolean', ['feature-state', 'hover'], false],
                                0.5,
                                0.3
                                ]
                        }            
                    },
                    firstSymbolId
                    );
                    e.target.addLayer({
                        'id': 'sn-layer-poll-shapes-lines',
                        'type': 'line',
                        'source': 'testmap-sn',
                        'minzoom': 13,
                        'maxzoom': 24,
                        'filter': [
                            "any",
                            ["!=", "Poll Winner", "???"]
                        ],
                        'paint': {
                            'line-opacity': 0.4,
                            'line-width': 2,
                            'line-color': [
                                'case',
                                ['all',partyStrengthSelected==='Poll Winner',['==', ['get', 'Poll Winner'],'Conservative']],
                                'rgba(9, 94, 230, 1)',
                                ['all',partyStrengthSelected==='Poll Winner',['==', ['get', 'Poll Winner'],'Progressive Conservative']],
                                'rgba(9, 94, 230, 1)',
                                ['all',partyStrengthSelected==='Poll Winner',['==', ['get', 'Poll Winner'],'United Conservative']],
                                'rgba(9, 94, 230, 1)',                                
                                ['all',partyStrengthSelected==='Poll Winner',['==', ['get', 'Poll Winner'],'Canadian Alliance']],
                                '#5ba963',
                                ['all',partyStrengthSelected==='Poll Winner',['==', ['get', 'Poll Winner'],'Alberta Party']],
                                '#f8c62e',                                
                                ['all',partyStrengthSelected==='Poll Winner',['==', ['get', 'Poll Winner'],'Wildrose']],
                                '#800080',                                                                                            
                                ['all',partyStrengthSelected==='Poll Winner',['==', ['get', 'Poll Winner'],'Alberta Independence']],
                                '#000000',                                
                                ['all',partyStrengthSelected==='Poll Winner',['==', ['get', 'Poll Winner'],'Liberal']],     
                                'rgba(230, 9, 9, 1)',
                                ['all',partyStrengthSelected==='Poll Winner',['==', ['get', 'Poll Winner'],'NDP-New Democratic Party']],
                                'rgba(230, 141, 9, 1)',
                                ['all',partyStrengthSelected==='Poll Winner',['==', ['get', 'Poll Winner'],'NDP']],
                                'rgba(230, 141, 9, 1)',
                                ['all',partyStrengthSelected==='Poll Winner',['==', ['get', 'Poll Winner'],'N.D.P.']],
                                'rgba(230, 141, 9, 1)',
                                ['all',partyStrengthSelected==='Poll Winner',['==', ['get', 'Poll Winner'],'Green Party']],
                                'rgba(0, 128, 0, 1)',
                                ['all',partyStrengthSelected==='Poll Winner',['==', ['get', 'Poll Winner'],'Green Party of Ontario']],
                                'rgba(0, 128, 0, 1)',
                                ['all',partyStrengthSelected==='Poll Winner',['==', ['get', 'Poll Winner'],'Ontario Green Party']],
                                'rgba(0, 128, 0, 1)',                                 
                                ['all',partyStrengthSelected==='Poll Winner',['==', ['get', 'Poll Winner'],'Bloc Québécois']],
                                '#0b9fd6',                    
                                ['all',partyStrengthSelected==='Poll Winner',['==', ['get', 'Poll Winner'],"People's Party - PPC"]],
                                '#7f0f7e',
                                ['all',partyStrengthSelected==='Poll Winner',['==', ['get', 'Poll Winner'],"Communist"]],
                                '#c47373',                                
                                ['all',partyStrengthSelected==='Poll Winner',['==', ['get', 'Poll Winner'],"People's Party"]],
                                '#7f0f7e',
                                ['all',partyStrengthSelected==='Poll Winner',['==', ['get', 'Poll Winner'],"Independent"]],
                                '#424242',
                                ['all',partyStrengthSelected==='Poll Winner',['==', ['get', 'Poll Winner'],"null"]],
                                '#000000',
                                ['all',partyStrengthSelected!=='Poll Winner',['!=', ['get', 'Poll Winner'],"null"]],
                                ['rgb', 
                                ["-",255,
                                    ["*",
                                        ["*",
                                            ["/",['get', candidateNameParty+' votes'],['get', 'Poll total votes']],
                                        255],
                                        ["/",0.5,["/",['get', candidateNameParty+' riding total'],['get', 'Riding total votes']]]
                                    ]
                                ],
                                ["*",
                                    ["*",
                                        ["/",['get', candidateNameParty+' votes'],['get', 'Poll total votes']],
                                    255],
                                    ["/",0.5,["/",['get', candidateNameParty+' riding total'],['get', 'Riding total votes']]]
                                ]
                                ,0],
                                ['all',partyStrengthSelected==='Riding Winnery',['!=', ['get', 'Poll Winner'],"null"]],
                                ['rgb', 
                                ["-",255,
                                    ["*",
                                        ["*",
                                            ["/",['get', 'Poll total votes'],['get', 'Electors']],
                                        255],
                                    ]
                                ],
                                ["*",
                                    ["*",
                                        ["/",['get', 'Poll total votes'],['get', 'Electors']],
                                    255],
                                ]
                                ,0],
                                '#424242'
                                
                            ]
                        }            
                    },
                    "highway_name_other"
                    );
                    e.target.addLayer({
                        'id': 'sn-layer-poll-shapes-lines-z0z13',
                        'type': 'line',
                        'source': 'testmap-sn',
                        'minzoom': 0,
                        'maxzoom': 13,
                        'filter': [
                            "any",
                            ["!=", "Poll Winner", "???"]
                        ],
                        'paint': {
                            'line-opacity': 1,
                            'line-width': 0.5,
                            'line-color': [
                                'case',
                                ['all',partyStrengthSelected==='Poll Winner',['==', ['get', 'Poll Winner'],'Conservative']],
                                'rgba(9, 94, 230, 1)',
                                ['all',partyStrengthSelected==='Poll Winner',['==', ['get', 'Poll Winner'],'Progressive Conservative']],
                                'rgba(9, 94, 230, 1)',
                                ['all',partyStrengthSelected==='Poll Winner',['==', ['get', 'Poll Winner'],'United Conservative']],
                                'rgba(9, 94, 230, 1)',                                
                                ['all',partyStrengthSelected==='Poll Winner',['==', ['get', 'Poll Winner'],'Canadian Alliance']],
                                '#5ba963',
                                ['all',partyStrengthSelected==='Poll Winner',['==', ['get', 'Poll Winner'],'Alberta Party']],
                                '#f8c62e',                                
                                ['all',partyStrengthSelected==='Poll Winner',['==', ['get', 'Poll Winner'],'Wildrose']],
                                '#800080',                                                                                            
                                ['all',partyStrengthSelected==='Poll Winner',['==', ['get', 'Poll Winner'],'Alberta Independence']],
                                '#000000',                                
                                ['all',partyStrengthSelected==='Poll Winner',['==', ['get', 'Poll Winner'],'Liberal']],     
                                'rgba(230, 9, 9, 1)',
                                ['all',partyStrengthSelected==='Poll Winner',['==', ['get', 'Poll Winner'],'NDP-New Democratic Party']],
                                'rgba(230, 141, 9, 1)',
                                ['all',partyStrengthSelected==='Poll Winner',['==', ['get', 'Poll Winner'],'NDP']],
                                'rgba(230, 141, 9, 1)',
                                ['all',partyStrengthSelected==='Poll Winner',['==', ['get', 'Poll Winner'],'N.D.P.']],
                                'rgba(230, 141, 9, 1)',
                                ['all',partyStrengthSelected==='Poll Winner',['==', ['get', 'Poll Winner'],'Green Party']],                                
                                'rgba(0, 128, 0, 1)',
                                ['all',partyStrengthSelected==='Poll Winner',['==', ['get', 'Poll Winner'],'Green Party of Ontario']],
                                'rgba(0, 128, 0, 1)',
                                ['all',partyStrengthSelected==='Poll Winner',['==', ['get', 'Poll Winner'],'Ontario Green Party']],
                                'rgba(0, 128, 0, 1)',                                
                                ['all',partyStrengthSelected==='Poll Winner',['==', ['get', 'Poll Winner'],'Bloc Québécois']],
                                '#0b9fd6',                    
                                ['all',partyStrengthSelected==='Poll Winner',['==', ['get', 'Poll Winner'],"People's Party - PPC"]],
                                '#7f0f7e',
                                ['all',partyStrengthSelected==='Poll Winner',['==', ['get', 'Poll Winner'],"Communist"]],
                                '#c47373',                                
                                ['all',partyStrengthSelected==='Poll Winner',['==', ['get', 'Poll Winner'],"People's Party"]],
                                '#7f0f7e',
                                ['all',partyStrengthSelected==='Poll Winner',['==', ['get', 'Poll Winner'],"Independent"]],
                                '#424242',
                                ['all',partyStrengthSelected==='Poll Winner',['==', ['get', 'Poll Winner'],"null"]],
                                '#000000',
                                ['all',partyStrengthSelected!=='Poll Winner',['!=', ['get', 'Poll Winner'],"null"]],
                                ['rgb', 
                                ["-",255,
                                    ["*",
                                        ["*",
                                            ["/",['get', candidateNameParty+' votes'],['get', 'Poll total votes']],
                                        255],
                                        ["/",0.5,["/",['get', candidateNameParty+' riding total'],['get', 'Riding total votes']]]
                                    ]
                                ],
                                ["*",
                                    ["*",
                                        ["/",['get', candidateNameParty+' votes'],['get', 'Poll total votes']],
                                    255],
                                    ["/",0.5,["/",['get', candidateNameParty+' riding total'],['get', 'Riding total votes']]]
                                ]
                                ,0],
                                ['all',partyStrengthSelected==='Riding Winnery',['!=', ['get', 'Poll Winner'],"null"]],
                                ['rgb', 
                                ["-",255,
                                    ["*",
                                        ["*",
                                            ["/",['get', 'Poll total votes'],['get', 'Electors']],
                                        255],
                                    ]
                                ],
                                ["*",
                                    ["*",
                                        ["/",['get', 'Poll total votes'],['get', 'Electors']],
                                    255],
                                ]
                                ,0],
                                '#424242'
                                
                            ]
                        }            
                    },
                    "highway_name_other"
                    );                                        
                } else {
                    e.target.addLayer({
                        'id': 'sn-layer-riding-shapes',
                        'type': 'fill',
                        'source': 'testmap-sn',
                        'maxzoom': 18,
                        'fill-antialias': false,
                        'filter': [
                            "any",
                            ["!=", "Poll Winner", "???"]
                        ],
                        'paint': {
                            'fill-color': [
                                'case',
                                ['all',['==', ['get', 'Winner'],'Conservative']],
                                'rgba(9, 94, 230, 1)',
                                ['all',['==', ['get', 'Winner'],'Progressive Conservative']],
                                'rgba(9, 94, 230, 1)',
                                ['all',['==', ['get', 'Winner'],'United Conservative']],
                                'rgba(9, 94, 230, 1)',                                
                                ['all',['==', ['get', 'Winner'],'Canadian Alliance']],
                                '#5ba963',
                                ['all',['==', ['get', 'Winner'],'Alberta Party']],
                                '#f8c62e',
                                ['all',['==', ['get', 'Winner'],'Wildrose']],
                                '#800080',                                                           
                                ['all',['==', ['get', 'Winner'],'Alberta Independence']],
                                '#000000',                                
                                ['all',['==', ['get', 'Winner'],'Liberal']],     
                                'rgba(230, 9, 9, 1)',
                                ['all',['==', ['get', 'Winner'],'Ontario Liberal Party']],     
                                'rgba(230, 9, 9, 1)',                                
                                ['all',['==', ['get', 'Winner'],'NDP-New Democratic Party']],
                                'rgba(230, 141, 9, 1)',
                                ['all',['==', ['get', 'Winner'],'NDP']],
                                'rgba(230, 141, 9, 1)',
                                ['all',['==', ['get', 'Winner'],'N.D.P.']],
                                'rgba(230, 141, 9, 1)',
                                ['all',['==', ['get', 'Winner'],'Green Party']],
                                'rgba(0, 128, 0, 1)',
                                ['all',['==', ['get', 'Winner'],'Ontario Green Party']],
                                'rgba(0, 128, 0, 1)',                                
                                ['all',['==', ['get', 'Winner'],'Green Party of Ontario']],
                                'rgba(0, 128, 0, 1)',                                                                
                                ['all',['==', ['get', 'Winner'],'Bloc Québécois']],
                                '#0b9fd6',                    
                                ['all',['==', ['get', 'Winner'],"People's Party - PPC"]],
                                '#7f0f7e',
                                ['all',['==', ['get', 'Winner'],"Communist"]],
                                '#c47373',                                
                                ['all',['==', ['get', 'Winner'],"People's Party"]],
                                '#7f0f7e',
                                ['all',['==', ['get', 'Winner'],"Independent"]],
                                '#424242',
                                ['all',['==', ['get', 'Winner'],"null"]],
                                '#000000',
                                ['all',['!=', ['get', 'Winner'],"null"]],
                                '#424242',
                                '#424242'
                                
                            ],
                            'fill-opacity': [
                                'case',
                                ['boolean', ['feature-state', 'hover'], false],
                                0.5,
                                0.3
                                ]
                        }            
                    },
                    firstSymbolId
                    );
                    e.target.addLayer({
                        'id': 'sn-layer-riding-shapes-lines',
                        'type': 'line',
                        'source': 'testmap-sn',
                        'minzoom': 12,
                        'maxzoom': 24,
                        'filter': [
                            "any",
                            ["!=", "Poll Winner", "???"]
                        ],
                        'paint': {
                            'line-opacity': 0.75,
                            'line-width': 2,
                            'line-color': [
                                'case',
                                ['all',['==', ['get', 'Winner'],'Conservative']],
                                'rgba(9, 94, 230, 1)',
                                ['all',['==', ['get', 'Winner'],'Progressive Conservative']],
                                'rgba(9, 94, 230, 1)',
                                ['all',['==', ['get', 'Winner'],'United Conservative']],
                                'rgba(9, 94, 230, 1)',
                                ['all',['==', ['get', 'Winner'],'Canadian Alliance']],
                                '#5ba963',
                                ['all',['==', ['get', 'Winner'],'Alberta Party']],
                                '#f8c62e',
                                ['all',['==', ['get', 'Winner'],'Wildrose']],
                                '#800080',                                
                                ['all',['==', ['get', 'Winner'],'Alberta Independence']],
                                '#000000',                                
                                ['all',['==', ['get', 'Winner'],'Liberal']],     
                                'rgba(230, 9, 9, 1)',
                                ['all',['==', ['get', 'Winner'],'Ontario Liberal Party']],     
                                'rgba(230, 9, 9, 1)',                                
                                ['all',['==', ['get', 'Winner'],'NDP-New Democratic Party']],
                                'rgba(230, 141, 9, 1)',
                                ['all',['==', ['get', 'Winner'],'NDP']],
                                'rgba(230, 141, 9, 1)',
                                ['all',['==', ['get', 'Winner'],'N.D.P.']],
                                'rgba(230, 141, 9, 1)',
                                ['all',['==', ['get', 'Winner'],'Green Party']],
                                'rgba(0, 128, 0, 1)',
                                ['all',['==', ['get', 'Winner'],'Ontario Green Party']],
                                'rgba(0, 128, 0, 1)',                                
                                ['all',['==', ['get', 'Winner'],'Green Party of Ontario']],
                                'rgba(0, 128, 0, 1)',                                                 
                                ['all',['==', ['get', 'Winner'],'Bloc Québécois']],
                                '#0b9fd6',                    
                                ['all',['==', ['get', 'Winner'],"People's Party - PPC"]],
                                '#7f0f7e',
                                ['all',['==', ['get', 'Winner'],"Communist"]],
                                '#c47373',                                                                
                                ['all',['==', ['get', 'Winner'],"People's Party"]],
                                '#7f0f7e',
                                ['all',['==', ['get', 'Winner'],"Independent"]],
                                '#424242',
                                ['all',['==', ['get', 'Winner'],"null"]],
                                '#000000',
                                ['all',['!=', ['get', 'Winner'],"null"]],
                                '#424242',
                                '#424242'
                                
                            ]
                        }            
                    },
                    "highway_name_other"
                    ); 
                    e.target.addLayer({
                        'id': 'sn-layer-riding-shapes-lines-z0z12',
                        'type': 'line',
                        'source': 'testmap-sn',
                        'minzoom': 0,
                        'maxzoom': 12,
                        'filter': [
                            "any",
                            ["!=", "Poll Winner", "???"]
                        ],
                        'paint': {
                            'line-opacity': 1,
                            'line-width': 0.5,
                            'line-color': [
                                'case',
                                ['all',['==', ['get', 'Winner'],'Conservative']],
                                'rgba(9, 94, 230, 1)',
                                ['all',['==', ['get', 'Winner'],'Progressive Conservative']],
                                'rgba(9, 94, 230, 1)',
                                ['all',['==', ['get', 'Winner'],'United Conservative']],
                                'rgba(9, 94, 230, 1)',
                                ['all',['==', ['get', 'Winner'],'Canadian Alliance']],
                                '#5ba963',
                                ['all',['==', ['get', 'Winner'],'Alberta Party']],
                                '#f8c62e',
                                ['all',['==', ['get', 'Winner'],'Wildrose']],
                                '#800080',                                
                                ['all',['==', ['get', 'Winner'],'Alberta Independence']],
                                '#000000',                                
                                ['all',['==', ['get', 'Winner'],'Liberal']],     
                                'rgba(230, 9, 9, 1)',
                                ['all',['==', ['get', 'Winner'],'Ontario Liberal Party']],     
                                'rgba(230, 9, 9, 1)',                                
                                ['all',['==', ['get', 'Winner'],'NDP-New Democratic Party']],
                                'rgba(230, 141, 9, 1)',
                                ['all',['==', ['get', 'Winner'],'NDP']],
                                'rgba(230, 141, 9, 1)',
                                ['all',['==', ['get', 'Winner'],'N.D.P.']],
                                'rgba(230, 141, 9, 1)',
                                ['all',['==', ['get', 'Winner'],'Green Party']],
                                'rgba(0, 128, 0, 1)',
                                ['all',['==', ['get', 'Winner'],'Ontario Green Party']],
                                'rgba(0, 128, 0, 1)',                                
                                ['all',['==', ['get', 'Winner'],'Green Party of Ontario']],
                                'rgba(0, 128, 0, 1)',                                                 
                                ['all',['==', ['get', 'Winner'],'Bloc Québécois']],
                                '#0b9fd6',                    
                                ['all',['==', ['get', 'Winner'],"People's Party - PPC"]],
                                '#7f0f7e',
                                ['all',['==', ['get', 'Winner'],"Communist"]],
                                '#c47373',                                                                
                                ['all',['==', ['get', 'Winner'],"People's Party"]],
                                '#7f0f7e',
                                ['all',['==', ['get', 'Winner'],"Independent"]],
                                '#424242',
                                ['all',['==', ['get', 'Winner'],"null"]],
                                '#000000',
                                ['all',['!=', ['get', 'Winner'],"null"]],
                                '#424242',
                                '#424242'
                                
                            ]
                        }            
                    },
                    "highway_name_other"
                    );                                        
                }    



        });
        map.current.fitBounds([
            props.data ? props.data.bounds[0] : [-142,41], // southwestern corner of the bounds
            props.data ? props.data.bounds[1] : [-50,65] // northeastern corner of the bounds
        ], {
            padding: {
                top: 100,
                bottom: 100,
                left: 100,
                right: 100,
            }
        });
        map.current.on('mouseenter', 'sn-layer-poll-shapes', () => {
            
        })
        map.current.on('mouseleave', 'sn-layer-poll-shapes', () => {
            mouseLeaveHighlight();
        })
        map.current.on('mousemove', 'sn-layer-poll-shapes', function (e) {
            setGraphVisible(true);
            setGraphDataObject(e.features[0].properties);
            mouseMoveHighlight(e);
        });
        map.current.on("click", "sn-layer-poll-shapes", (e) => {
            doMapModal(e);
        });

        map.current.on('mousemove', function (e) {
            //var features = map.current.queryRenderedFeatures(e.point);
            //console.log(features)
        });

        map.current.on('mouseenter', 'sn-layer-riding-shapes', (e) => {
        })

        map.current.on('mouseleave', 'sn-layer-riding-shapes', () => {
            //setGraphDataObject([]);
            mouseLeaveHighlight();
        })
        map.current.on('mousemove', 'sn-layer-riding-shapes', function (e) {
            setGraphVisible(true);
            setGraphDataObject(e.features[0].properties);
            mouseMoveHighlight(e);
        });
        map.current.on("click", "sn-layer-riding-shapes", (e) => {
            setRiding(e.features[0].properties['Riding ID'], e.features[0].properties['Election'], e.features[0]['properties']);
        });        
        
        if (mapObj !== null) {
            if (props.data) {
            setLoading(1);
            
            fetch(
                props.data.geojson_url, { crossDomain:true }
            )
                .then((res) => res.text())
                .then((geojsontext) => { 
                var geojsonlayer = JSON.parse(geojsontext);

                if (mapObj.event === 'Election') {
                    politicalParties = [];
                    var parties = geojsonlayer.features[0].properties.Candidates;
                    for (var i=0;i<parties.length;i++) {
                        politicalParties.push(parties[i].party);
                    }

                    
                    var partyvotes = [];
                    var candidatePartyVotes = [];
                    var partyStrengthAdjustmentFactor = [];
                    var maxPartyVoteinAPoll;
                    var ridingtotalvotes = 0;
                    var paf = [];
                
                    // create the party vote array
                    for (var i=0;i<geojsonlayer.features[0].properties['Candidates'].length;i++) {
                        partyvotes[geojsonlayer.features[0].properties['Candidates'][i].party] = 0;
                        paf[geojsonlayer.features[0].properties['Candidates'][i].party] = 0;
                    }

                    // create the candidatePartyVotes array
                    for (var i=0;i<geojsonlayer.features[0].properties['Candidates'].length;i++) {
                        candidatePartyVotes.push([geojsonlayer.features[0].properties['Candidates'][i].name+' '+geojsonlayer.features[0].properties['Candidates'][i].party, geojsonlayer.features[0].properties[geojsonlayer.features[0].properties['Candidates'][i].name+' '+geojsonlayer.features[0].properties['Candidates'][i].party+' riding total']]);
                    }                        

                    for (var j=0; j<geojsonlayer.features.length; j++) {
                        if (geojsonlayer.features[j].properties.hasOwnProperty('Candidates')) {
                            for (var i=0;i<geojsonlayer.features[j].properties['Candidates'].length;i++) {
                                partyvotes[geojsonlayer.features[j].properties['Candidates'][i].party] = partyvotes[geojsonlayer.features[j].properties['Candidates'][i].party] + geojsonlayer.features[j].properties['Candidates'][i].votes;
                                ridingtotalvotes += geojsonlayer.features[j].properties['Candidates'][i].votes;
                            }
                        }      
                    }
                    
                    setSortedParty(getSortedKeys(partyvotes));
                    //candidatePartyVotes = getSortedKeys(partyvotes);
                    candidatePartyVotes.sort(function(a, b) {
                        return b[1] - a[1];
                    });
                    var simplifiedCPV = [];
                    for (var i=0;i<candidatePartyVotes.length;i++) {
                        simplifiedCPV.push(candidatePartyVotes[i][0]);
                    }
                    setCPVOrder(simplifiedCPV);
                    for (var i=0;i<geojsonlayer.features[0].properties['Candidates'].length;i++) {
                        paf[geojsonlayer.features[0].properties['Candidates'][i].party] = paf[geojsonlayer.features[0].properties['Candidates'][i].party] + (0.5 / ( partyvotes[geojsonlayer.features[0].properties['Candidates'][i].party] / ridingtotalvotes ));
                    }
                    setoverlayLayer(geojsonlayer);
                    setPartyAdjustmentFactor(paf);
                    setTheParties([]);
                    setTheParties(sortedParty);
                    
                    //map.current.addControl(<PartyStrengthControl data={{sortedParty: sortedParty, winner: mapObj.winner, selected: partyStrengthSelected, cpvOrder: cPVOrder}}/>);
                }

                if (mapObj.event === 'Leadership') {
                    leadershipRounds = [];
                    var rounds = geojsonlayer.features[0].properties.Rounds;
                    for (var i=0;i<rounds.length;i++) {
                    leadershipRounds.push(i);
                    }

                    setTheLeadershipRounds([]);
                    setTheLeadershipRounds(leadershipRounds);
                }

                setLoading(0);                  

                })
            }
        }
        setMapLoad(0);
        
    }, [props.data ? props.data.geojson_url : '', firstSymbolId, props.data ? props.data.minor_jurisdiction : '']);

    useEffect(() => {
        if ((props && props.data && props.data.minor_jurisdiction !== 'Canada' && props.data.event_type === 'Federal') || (props && props.data && props.data.map_context !== 'Provincial' && props.data.event_type === 'Provincial')) {
            if (candidateNameParty == 'Poll Winner') {
                setPartyStrengthSelected('Poll Winner');
            } else {
                setPartyStrengthSelected(partyParty);
            }            

            var layers = map.current.getStyle().layers;
            for (var i = 0; i < layers.length; i++) {
                if (layers[i].type === 'symbol') {
                    firstSymbolId = layers[i].id;
                    break;
                }
            }

            var strengthLayer = map.current.getLayer('sn-layer-poll-shapes');
            if (map.current.getSource('testmap-sn')) {
                if (typeof strengthLayer !== 'undefined') {
                    map.current.removeLayer('sn-layer-poll-shapes');
                    map.current.removeLayer('sn-layer-poll-shapes-lines');
                    map.current.removeLayer('sn-layer-poll-shapes-lines-z0z13');
                }
                if (typeof strengthLayer === 'undefined') {
                    map.current.addLayer({
                        'id': 'sn-layer-poll-shapes',
                        'type': 'fill',
                        'source': 'testmap-sn',
                        'maxzoom': 24,
                        'fill-antialias': false,
                        'filter': [
                            "any",
                            ["!=", "Poll Winner", "???"]
                        ],
                        'paint': {
                            'fill-color': [
                                'let',
                                'padj',
                                ["*",
                                    ["*",
                                        ["/",
                                            ['get', candidateNameParty+' votes'], // "EE"
                                            ['get', 'Poll total votes'] // "FF"
                                        ],  // divide "EE" by "FF"
                                        100 // multiply the result by 100
                                    ], // result is "DD"
                                    ["/",
                                        0.5,
                                        ["/",
                                            ['get', candidateNameParty+' riding total'], // " GG"
                                            ['get', 'Riding total votes'] // "JJ"
                                        ] // divide "GG" by "JJ". The result is "KK"
                                    ] // divide 0.5 by "KK". Result is "LL"
                                ], // multiply "DD" by "LL". Result is "MM".
                                ['case',
                                ['all',partyStrengthSelected==='Poll Winner',['==', ['get', 'Poll Winner'],'Conservative']],
                                'rgba(9, 94, 230, 1)',
                                ['all',partyStrengthSelected==='Poll Winner',['==', ['get', 'Poll Winner'],'Progressive Conservative']],
                                'rgba(9, 94, 230, 1)',
                                ['all',partyStrengthSelected==='Poll Winner',['==', ['get', 'Poll Winner'],'United Conservative']],
                                'rgba(9, 94, 230, 1)',
                                ['all',partyStrengthSelected==='Poll Winner',['==', ['get', 'Poll Winner'],'Canadian Alliance']],
                                '#5ba963',
                                ['all',partyStrengthSelected==='Poll Winner',['==', ['get', 'Poll Winner'],'Alberta Party']],
                                '#f8c62e',
                                ['all',partyStrengthSelected==='Poll Winner',['==', ['get', 'Poll Winner'],'Wildrose']],
                                '#800080',                                                                                           
                                ['all',partyStrengthSelected==='Poll Winner',['==', ['get', 'Poll Winner'],'Alberta Independence']],
                                '#000000',                                
                                ['all',partyStrengthSelected==='Poll Winner',['==', ['get', 'Poll Winner'],'Liberal']],     
                                'rgba(230, 9, 9, 1)',
                                ['all',partyStrengthSelected==='Poll Winner',['==', ['get', 'Poll Winner'],'Ontario Liberal Party']],     
                                'rgba(230, 9, 9, 1)',                                
                                ['all',partyStrengthSelected==='Poll Winner',['==', ['get', 'Poll Winner'],'NDP-New Democratic Party']],
                                'rgba(230, 141, 9, 1)',
                                ['all',partyStrengthSelected==='Poll Winner',['==', ['get', 'Poll Winner'],'NDP']],
                                'rgba(230, 141, 9, 1)',
                                ['all',partyStrengthSelected==='Poll Winner',['==', ['get', 'Poll Winner'],'N.D.P.']],
                                'rgba(230, 141, 9, 1)',
                                ['all',partyStrengthSelected==='Poll Winner',['==', ['get', 'Poll Winner'],'Green Party']],
                                'rgba(0, 128, 0, 1)',
                                ['all',partyStrengthSelected==='Poll Winner',['==', ['get', 'Poll Winner'],'Ontario Green Party']],
                                'rgba(0, 128, 0, 1)',                                
                                ['all',partyStrengthSelected==='Poll Winner',['==', ['get', 'Poll Winner'],'Green Party of Ontario']],
                                'rgba(0, 128, 0, 1)',                                                                
                                ['all',partyStrengthSelected==='Poll Winner',['==', ['get', 'Poll Winner'],'Bloc Québécois']],
                                '#0b9fd6',                    
                                ['all',partyStrengthSelected==='Poll Winner',['==', ['get', 'Poll Winner'],"People's Party - PPC"]],
                                '#7f0f7e',
                                ['all',partyStrengthSelected==='Poll Winner',['==', ['get', 'Poll Winner'],"Communist"]],
                                '#c47373',                                                                                            
                                ['all',partyStrengthSelected==='Poll Winner',['==', ['get', 'Poll Winner'],"People's Party"]],
                                '#7f0f7e',
                                ['all',partyStrengthSelected==='Poll Winner',['==', ['get', 'Poll Winner'],"Independent"]],
                                '#424242',
                                ['all',partyStrengthSelected==='Poll Winner',['==', ['get', 'Poll Winner'],"null"]],
                                '#000000',
                                ['all',partyStrengthSelected!=='Poll Winner',['!=', ['get', 'Poll Winner'],"null"]],
                                ['rgb', 
                                    ["case",
                                        [">=",
                                            ["var","padj"],
                                            70
                                        ], 
                                        CLOROTHEME.theme1.red['70'], // red component if result is greater than or equal to 70
                                        [">=",
                                            ["var","padj"],
                                            65
                                        ], 
                                        CLOROTHEME.theme1.red['65'], // red component if result is greater than or equal to 65
                                        [">=",
                                            ["var","padj"],
                                            60
                                        ], 
                                        CLOROTHEME.theme1.red['60'], // red component if result is greater than or equal to 60
                                        [">=",
                                            ["var","padj"],
                                            55
                                        ], 
                                        CLOROTHEME.theme1.red['55'], // red component if result is greater than or equal to 55
                                        [">=",
                                            ["var","padj"],
                                            50
                                        ], 
                                        CLOROTHEME.theme1.red['50'], // red component if result is greater than or equal to 50
                                        [">=",
                                            ["var","padj"],
                                            45
                                        ], 
                                        CLOROTHEME.theme1.red['45'], // red component if result is greater than or equal to 45
                                        [">=",
                                            ["var","padj"],
                                            40
                                        ], 
                                        CLOROTHEME.theme1.red['40'], // red component if result is greater than or equal to 40
                                        [">=",
                                            ["var","padj"],
                                            35
                                        ], 
                                        CLOROTHEME.theme1.red['35'], // red component if result is greater than or equal to 35
                                        [">=",
                                            ["var","padj"],
                                            30
                                        ], 
                                        CLOROTHEME.theme1.red['25'], // red component if result is greater than or equal to 30
                                        [">=",
                                            ["var","padj"],
                                            25
                                        ], 
                                        CLOROTHEME.theme1.red['25'], // red component if result is greater than or equal to 25
                                        CLOROTHEME.theme1.red['25'] // red component if results is less than 25
                                    ],
                                    ["case",
                                        [">=",
                                            ["var","padj"],
                                            70
                                        ], 
                                        CLOROTHEME.theme1.green['70'], // red component if result is greater than or equal to 70
                                        [">=",
                                            ["var","padj"],
                                            65
                                        ], 
                                        CLOROTHEME.theme1.green['65'], // red component if result is greater than or equal to 65
                                        [">=",
                                            ["var","padj"],
                                            60
                                        ], 
                                        CLOROTHEME.theme1.green['60'], // red component if result is greater than or equal to 60
                                        [">=",
                                            ["var","padj"],
                                            55
                                        ], 
                                        CLOROTHEME.theme1.green['55'], // red component if result is greater than or equal to 55
                                        [">=",
                                            ["var","padj"],
                                            50
                                        ], 
                                        CLOROTHEME.theme1.green['50'], // red component if result is greater than or equal to 50
                                        [">=",
                                            ["var","padj"],
                                            45
                                        ], 
                                        CLOROTHEME.theme1.green['45'], // red component if result is greater than or equal to 45
                                        [">=",
                                            ["var","padj"],
                                            40
                                        ], 
                                        CLOROTHEME.theme1.green['40'], // red component if result is greater than or equal to 40
                                        [">=",
                                            ["var","padj"],
                                            35
                                        ], 
                                        CLOROTHEME.theme1.green['35'], // red component if result is greater than or equal to 35
                                        [">=",
                                            ["var","padj"],
                                            30
                                        ], 
                                        CLOROTHEME.theme1.green['30'], // red component if result is greater than or equal to 30
                                        [">=",
                                            ["var","padj"],
                                            25
                                        ], 
                                        CLOROTHEME.theme1.green['25'], // red component if result is greater than or equal to 25
                                        CLOROTHEME.theme1.green['25'] // red component if results is less than 25
                                    ],
                                    ["case",
                                        [">=",
                                            ["var","padj"],
                                            70
                                        ], 
                                        CLOROTHEME.theme1.blue['70'], // red component if result is greater than or equal to 70
                                        [">=",
                                            ["var","padj"],
                                            65
                                        ], 
                                        CLOROTHEME.theme1.blue['65'], // red component if result is greater than or equal to 65
                                        [">=",
                                            ["var","padj"],
                                            60
                                        ], 
                                        CLOROTHEME.theme1.blue['60'], // red component if result is greater than or equal to 60
                                        [">=",
                                            ["var","padj"],
                                            55
                                        ], 
                                        CLOROTHEME.theme1.blue['55'], // red component if result is greater than or equal to 55
                                        [">=",
                                            ["var","padj"],
                                            50
                                        ], 
                                        CLOROTHEME.theme1.blue['50'], // red component if result is greater than or equal to 50
                                        [">=",
                                            ["var","padj"],
                                            45
                                        ], 
                                        CLOROTHEME.theme1.blue['45'], // red component if result is greater than or equal to 45
                                        [">=",
                                            ["var","padj"],
                                            40
                                        ], 
                                        CLOROTHEME.theme1.blue['40'], // red component if result is greater than or equal to 40
                                        [">=",
                                            ["var","padj"],
                                            35
                                        ], 
                                        CLOROTHEME.theme1.blue['35'], // red component if result is greater than or equal to 35
                                        [">=",
                                            ["var","padj"],
                                            30
                                        ], 
                                        CLOROTHEME.theme1.blue['35'], // red component if result is greater than or equal to 30
                                        [">=",
                                            ["var","padj"],
                                            25
                                        ], 
                                        CLOROTHEME.theme1.blue['25'], // red component if result is greater than or equal to 25
                                        CLOROTHEME.theme1.blue['25'] // red component if results is less than 25
                                    ]
                                ],
                                ['all',partyStrengthSelected==='Riding Winnery',['!=', ['get', 'Poll Winner'],"null"]],
                                ['rgb', 
                                ["-",255,
                                    ["*",
                                        ["*",
                                            ["/",['get', 'Poll total votes'],['get', 'Electors']],
                                        255],
                                    ]
                                ],
                                ["*",
                                    ["*",
                                        ["/",['get', 'Poll total votes'],['get', 'Electors']],
                                    255],
                                ]
                                ,0],
                                '#424242'
                                
                                ],
                            ],
                            'fill-opacity': [
                                'case',
                                ['boolean', ['feature-state', 'hover'], false],
                                0.5,
                                0.3
                                ]
                        }            
                    },
                    firstSymbolId
                    );  
                    map.current.addLayer({
                        'id': 'sn-layer-poll-shapes-lines',
                        'type': 'line',
                        'source': 'testmap-sn',
                        'minzoom': 13,
                        'maxzoom': 24,
                        'filter': [
                            "any",
                            ["!=", "Poll Winner", "???"]
                        ],
                        'paint': {
                            'line-opacity': 0.4,
                            'line-width': 2,
                            'line-color': [
                                'let',
                                'padj',
                                ["*",
                                    ["*",
                                        ["/",
                                            ['get', candidateNameParty+' votes'], // "EE"
                                            ['get', 'Poll total votes'] // "FF"
                                        ],  // divide "EE" by "FF"
                                        100 // multiply the result by 100
                                    ], // result is "DD"
                                    ["/",
                                        0.5,
                                        ["/",
                                            ['get', candidateNameParty+' riding total'], // " GG"
                                            ['get', 'Riding total votes'] // "JJ"
                                        ] // divide "GG" by "JJ". The result is "KK"
                                    ] // divide 0.5 by "KK". Result is "LL"
                                ], // multiply "DD" by "LL". Result is "MM".
                                ['case',
                                ['all',partyStrengthSelected==='Poll Winner',['==', ['get', 'Poll Winner'],'Conservative']],
                                'rgba(9, 94, 230, 1)',
                                ['all',partyStrengthSelected==='Poll Winner',['==', ['get', 'Poll Winner'],'Progressive Conservative']],
                                'rgba(9, 94, 230, 1)',
                                ['all',partyStrengthSelected==='Poll Winner',['==', ['get', 'Poll Winner'],'United Conservative']],
                                'rgba(9, 94, 230, 1)',                                
                                ['all',partyStrengthSelected==='Poll Winner',['==', ['get', 'Poll Winner'],'Canadian Alliance']],
                                '#5ba963',
                                ['all',partyStrengthSelected==='Poll Winner',['==', ['get', 'Poll Winner'],'Alberta Party']],
                                '#f8c62e',                                
                                ['all',partyStrengthSelected==='Poll Winner',['==', ['get', 'Poll Winner'],'Wildrose']],
                                '#800080',                                                                                           
                                ['all',partyStrengthSelected==='Poll Winner',['==', ['get', 'Poll Winner'],'Alberta Independence']],
                                '#000000',                                
                                ['all',partyStrengthSelected==='Poll Winner',['==', ['get', 'Poll Winner'],'Liberal']],     
                                'rgba(230, 9, 9, 1)',
                                ['all',partyStrengthSelected==='Poll Winner',['==', ['get', 'Poll Winner'],'NDP-New Democratic Party']],
                                'rgba(230, 141, 9, 1)',
                                ['all',partyStrengthSelected==='Poll Winner',['==', ['get', 'Poll Winner'],'NDP']],
                                'rgba(230, 141, 9, 1)',
                                ['all',partyStrengthSelected==='Poll Winner',['==', ['get', 'Poll Winner'],'N.D.P.']],
                                'rgba(230, 141, 9, 1)',
                                ['all',partyStrengthSelected==='Poll Winner',['==', ['get', 'Poll Winner'],'Green Party']],
                                'rgba(0, 128, 0, 1)',
                                ['all',partyStrengthSelected==='Poll Winner',['==', ['get', 'Poll Winner'],'Bloc Québécois']],
                                '#0b9fd6',                    
                                ['all',partyStrengthSelected==='Poll Winner',['==', ['get', 'Poll Winner'],"People's Party - PPC"]],
                                '#7f0f7e',
                                ['all',partyStrengthSelected==='Poll Winner',['==', ['get', 'Poll Winner'],"Communist"]],
                                '#c47373',                                                                                            
                                ['all',partyStrengthSelected==='Poll Winner',['==', ['get', 'Poll Winner'],"People's Party"]],
                                '#7f0f7e',
                                ['all',partyStrengthSelected==='Poll Winner',['==', ['get', 'Poll Winner'],"Independent"]],
                                '#424242',
                                ['all',partyStrengthSelected==='Poll Winner',['==', ['get', 'Poll Winner'],"null"]],
                                '#000000',
                                ['all',partyStrengthSelected!=='Poll Winner',['!=', ['get', 'Poll Winner'],"null"]],
                                ['rgb', 
                                    ["case",
                                        [">=",
                                            ["var","padj"],
                                            70
                                        ], 
                                        CLOROTHEME.theme1.red['70'], // red component if result is greater than or equal to 70
                                        [">=",
                                            ["var","padj"],
                                            65
                                        ], 
                                        CLOROTHEME.theme1.red['65'], // red component if result is greater than or equal to 65
                                        [">=",
                                            ["var","padj"],
                                            60
                                        ], 
                                        CLOROTHEME.theme1.red['60'], // red component if result is greater than or equal to 60
                                        [">=",
                                            ["var","padj"],
                                            55
                                        ], 
                                        CLOROTHEME.theme1.red['55'], // red component if result is greater than or equal to 55
                                        [">=",
                                            ["var","padj"],
                                            50
                                        ], 
                                        CLOROTHEME.theme1.red['50'], // red component if result is greater than or equal to 50
                                        [">=",
                                            ["var","padj"],
                                            45
                                        ], 
                                        CLOROTHEME.theme1.red['45'], // red component if result is greater than or equal to 45
                                        [">=",
                                            ["var","padj"],
                                            40
                                        ], 
                                        CLOROTHEME.theme1.red['40'], // red component if result is greater than or equal to 40
                                        [">=",
                                            ["var","padj"],
                                            35
                                        ], 
                                        CLOROTHEME.theme1.red['35'], // red component if result is greater than or equal to 35
                                        [">=",
                                            ["var","padj"],
                                            30
                                        ], 
                                        CLOROTHEME.theme1.red['25'], // red component if result is greater than or equal to 30
                                        [">=",
                                            ["var","padj"],
                                            25
                                        ], 
                                        CLOROTHEME.theme1.red['25'], // red component if result is greater than or equal to 25
                                        CLOROTHEME.theme1.red['25'] // red component if results is less than 25
                                    ],
                                    ["case",
                                        [">=",
                                            ["var","padj"],
                                            70
                                        ], 
                                        CLOROTHEME.theme1.green['70'], // red component if result is greater than or equal to 70
                                        [">=",
                                            ["var","padj"],
                                            65
                                        ], 
                                        CLOROTHEME.theme1.green['65'], // red component if result is greater than or equal to 65
                                        [">=",
                                            ["var","padj"],
                                            60
                                        ], 
                                        CLOROTHEME.theme1.green['60'], // red component if result is greater than or equal to 60
                                        [">=",
                                            ["var","padj"],
                                            55
                                        ], 
                                        CLOROTHEME.theme1.green['55'], // red component if result is greater than or equal to 55
                                        [">=",
                                            ["var","padj"],
                                            50
                                        ], 
                                        CLOROTHEME.theme1.green['50'], // red component if result is greater than or equal to 50
                                        [">=",
                                            ["var","padj"],
                                            45
                                        ], 
                                        CLOROTHEME.theme1.green['45'], // red component if result is greater than or equal to 45
                                        [">=",
                                            ["var","padj"],
                                            40
                                        ], 
                                        CLOROTHEME.theme1.green['40'], // red component if result is greater than or equal to 40
                                        [">=",
                                            ["var","padj"],
                                            35
                                        ], 
                                        CLOROTHEME.theme1.green['35'], // red component if result is greater than or equal to 35
                                        [">=",
                                            ["var","padj"],
                                            30
                                        ], 
                                        CLOROTHEME.theme1.green['30'], // red component if result is greater than or equal to 30
                                        [">=",
                                            ["var","padj"],
                                            25
                                        ], 
                                        CLOROTHEME.theme1.green['25'], // red component if result is greater than or equal to 25
                                        CLOROTHEME.theme1.green['25'] // red component if results is less than 25
                                    ],
                                    ["case",
                                        [">=",
                                            ["var","padj"],
                                            70
                                        ], 
                                        CLOROTHEME.theme1.blue['70'], // red component if result is greater than or equal to 70
                                        [">=",
                                            ["var","padj"],
                                            65
                                        ], 
                                        CLOROTHEME.theme1.blue['65'], // red component if result is greater than or equal to 65
                                        [">=",
                                            ["var","padj"],
                                            60
                                        ], 
                                        CLOROTHEME.theme1.blue['60'], // red component if result is greater than or equal to 60
                                        [">=",
                                            ["var","padj"],
                                            55
                                        ], 
                                        CLOROTHEME.theme1.blue['55'], // red component if result is greater than or equal to 55
                                        [">=",
                                            ["var","padj"],
                                            50
                                        ], 
                                        CLOROTHEME.theme1.blue['50'], // red component if result is greater than or equal to 50
                                        [">=",
                                            ["var","padj"],
                                            45
                                        ], 
                                        CLOROTHEME.theme1.blue['45'], // red component if result is greater than or equal to 45
                                        [">=",
                                            ["var","padj"],
                                            40
                                        ], 
                                        CLOROTHEME.theme1.blue['40'], // red component if result is greater than or equal to 40
                                        [">=",
                                            ["var","padj"],
                                            35
                                        ], 
                                        CLOROTHEME.theme1.blue['35'], // red component if result is greater than or equal to 35
                                        [">=",
                                            ["var","padj"],
                                            30
                                        ], 
                                        CLOROTHEME.theme1.blue['35'], // red component if result is greater than or equal to 30
                                        [">=",
                                            ["var","padj"],
                                            25
                                        ], 
                                        CLOROTHEME.theme1.blue['25'], // red component if result is greater than or equal to 25
                                        CLOROTHEME.theme1.blue['25'] // red component if results is less than 25
                                    ]
                                ],
                                ['all',partyStrengthSelected==='Riding Winnery',['!=', ['get', 'Poll Winner'],"null"]],
                                ['rgb', 
                                ["-",255,
                                    ["*",
                                        ["*",
                                            ["/",['get', 'Poll total votes'],['get', 'Electors']],
                                        255],
                                    ]
                                ],
                                ["*",
                                    ["*",
                                        ["/",['get', 'Poll total votes'],['get', 'Electors']],
                                    255],
                                ]
                                ,0],
                                '#424242'
                                
                                ],
                            ]
                        }            
                    },
                    "highway_name_other"
                    );
                    map.current.addLayer({
                        'id': 'sn-layer-poll-shapes-lines-z0z13',
                        'type': 'line',
                        'source': 'testmap-sn',
                        'minzoom': 0,
                        'maxzoom': 13,
                        'filter': [
                            "any",
                            ["!=", "Poll Winner", "???"]
                        ],
                        'paint': {
                            'line-opacity': 1,
                            'line-width': 0.5,
                            'line-color': [
                                'let',
                                'padj',
                                ["*",
                                    ["*",
                                        ["/",
                                            ['get', candidateNameParty+' votes'], // "EE"
                                            ['get', 'Poll total votes'] // "FF"
                                        ],  // divide "EE" by "FF"
                                        100 // multiply the result by 100
                                    ], // result is "DD"
                                    ["/",
                                        0.5,
                                        ["/",
                                            ['get', candidateNameParty+' riding total'], // " GG"
                                            ['get', 'Riding total votes'] // "JJ"
                                        ] // divide "GG" by "JJ". The result is "KK"
                                    ] // divide 0.5 by "KK". Result is "LL"
                                ], // multiply "DD" by "LL". Result is "MM".
                                ['case',
                                ['all',partyStrengthSelected==='Poll Winner',['==', ['get', 'Poll Winner'],'Conservative']],
                                'rgba(9, 94, 230, 1)',
                                ['all',partyStrengthSelected==='Poll Winner',['==', ['get', 'Poll Winner'],'Progressive Conservative']],
                                'rgba(9, 94, 230, 1)',
                                ['all',partyStrengthSelected==='Poll Winner',['==', ['get', 'Poll Winner'],'United Conservative']],
                                'rgba(9, 94, 230, 1)',
                                ['all',partyStrengthSelected==='Poll Winner',['==', ['get', 'Poll Winner'],'Canadian Alliance']],
                                '#5ba963',
                                ['all',partyStrengthSelected==='Poll Winner',['==', ['get', 'Poll Winner'],'Alberta Party']],
                                '#f8c62e',                                
                                ['all',partyStrengthSelected==='Poll Winner',['==', ['get', 'Poll Winner'],'Wildrose']],
                                '#800080',                                                                                           
                                ['all',partyStrengthSelected==='Poll Winner',['==', ['get', 'Poll Winner'],'Alberta Independence']],
                                '#000000',                                
                                ['all',partyStrengthSelected==='Poll Winner',['==', ['get', 'Poll Winner'],'Liberal']],     
                                'rgba(230, 9, 9, 1)',
                                ['all',partyStrengthSelected==='Poll Winner',['==', ['get', 'Poll Winner'],'NDP-New Democratic Party']],
                                'rgba(230, 141, 9, 1)',
                                ['all',partyStrengthSelected==='Poll Winner',['==', ['get', 'Poll Winner'],'NDP']],
                                'rgba(230, 141, 9, 1)',
                                ['all',partyStrengthSelected==='Poll Winner',['==', ['get', 'Poll Winner'],'N.D.P.']],
                                'rgba(230, 141, 9, 1)',
                                ['all',partyStrengthSelected==='Poll Winner',['==', ['get', 'Poll Winner'],'Green Party']],
                                'rgba(0, 128, 0, 1)',
                                ['all',partyStrengthSelected==='Poll Winner',['==', ['get', 'Poll Winner'],'Bloc Québécois']],
                                '#0b9fd6',                    
                                ['all',partyStrengthSelected==='Poll Winner',['==', ['get', 'Poll Winner'],"People's Party - PPC"]],
                                '#7f0f7e',
                                ['all',partyStrengthSelected==='Poll Winner',['==', ['get', 'Poll Winner'],"Communist"]],
                                '#c47373',                                                                                            
                                ['all',partyStrengthSelected==='Poll Winner',['==', ['get', 'Poll Winner'],"People's Party"]],
                                '#7f0f7e',
                                ['all',partyStrengthSelected==='Poll Winner',['==', ['get', 'Poll Winner'],"Independent"]],
                                '#424242',
                                ['all',partyStrengthSelected==='Poll Winner',['==', ['get', 'Poll Winner'],"null"]],
                                '#000000',
                                ['all',partyStrengthSelected!=='Poll Winner',['!=', ['get', 'Poll Winner'],"null"]],
                                ['rgb', 
                                    ["case",
                                        [">=",
                                            ["var","padj"],
                                            70
                                        ], 
                                        CLOROTHEME.theme1.red['70'], // red component if result is greater than or equal to 70
                                        [">=",
                                            ["var","padj"],
                                            65
                                        ], 
                                        CLOROTHEME.theme1.red['65'], // red component if result is greater than or equal to 65
                                        [">=",
                                            ["var","padj"],
                                            60
                                        ], 
                                        CLOROTHEME.theme1.red['60'], // red component if result is greater than or equal to 60
                                        [">=",
                                            ["var","padj"],
                                            55
                                        ], 
                                        CLOROTHEME.theme1.red['55'], // red component if result is greater than or equal to 55
                                        [">=",
                                            ["var","padj"],
                                            50
                                        ], 
                                        CLOROTHEME.theme1.red['50'], // red component if result is greater than or equal to 50
                                        [">=",
                                            ["var","padj"],
                                            45
                                        ], 
                                        CLOROTHEME.theme1.red['45'], // red component if result is greater than or equal to 45
                                        [">=",
                                            ["var","padj"],
                                            40
                                        ], 
                                        CLOROTHEME.theme1.red['40'], // red component if result is greater than or equal to 40
                                        [">=",
                                            ["var","padj"],
                                            35
                                        ], 
                                        CLOROTHEME.theme1.red['35'], // red component if result is greater than or equal to 35
                                        [">=",
                                            ["var","padj"],
                                            30
                                        ], 
                                        CLOROTHEME.theme1.red['25'], // red component if result is greater than or equal to 30
                                        [">=",
                                            ["var","padj"],
                                            25
                                        ], 
                                        CLOROTHEME.theme1.red['25'], // red component if result is greater than or equal to 25
                                        CLOROTHEME.theme1.red['25'] // red component if results is less than 25
                                    ],
                                    ["case",
                                        [">=",
                                            ["var","padj"],
                                            70
                                        ], 
                                        CLOROTHEME.theme1.green['70'], // red component if result is greater than or equal to 70
                                        [">=",
                                            ["var","padj"],
                                            65
                                        ], 
                                        CLOROTHEME.theme1.green['65'], // red component if result is greater than or equal to 65
                                        [">=",
                                            ["var","padj"],
                                            60
                                        ], 
                                        CLOROTHEME.theme1.green['60'], // red component if result is greater than or equal to 60
                                        [">=",
                                            ["var","padj"],
                                            55
                                        ], 
                                        CLOROTHEME.theme1.green['55'], // red component if result is greater than or equal to 55
                                        [">=",
                                            ["var","padj"],
                                            50
                                        ], 
                                        CLOROTHEME.theme1.green['50'], // red component if result is greater than or equal to 50
                                        [">=",
                                            ["var","padj"],
                                            45
                                        ], 
                                        CLOROTHEME.theme1.green['45'], // red component if result is greater than or equal to 45
                                        [">=",
                                            ["var","padj"],
                                            40
                                        ], 
                                        CLOROTHEME.theme1.green['40'], // red component if result is greater than or equal to 40
                                        [">=",
                                            ["var","padj"],
                                            35
                                        ], 
                                        CLOROTHEME.theme1.green['35'], // red component if result is greater than or equal to 35
                                        [">=",
                                            ["var","padj"],
                                            30
                                        ], 
                                        CLOROTHEME.theme1.green['30'], // red component if result is greater than or equal to 30
                                        [">=",
                                            ["var","padj"],
                                            25
                                        ], 
                                        CLOROTHEME.theme1.green['25'], // red component if result is greater than or equal to 25
                                        CLOROTHEME.theme1.green['25'] // red component if results is less than 25
                                    ],
                                    ["case",
                                        [">=",
                                            ["var","padj"],
                                            70
                                        ], 
                                        CLOROTHEME.theme1.blue['70'], // red component if result is greater than or equal to 70
                                        [">=",
                                            ["var","padj"],
                                            65
                                        ], 
                                        CLOROTHEME.theme1.blue['65'], // red component if result is greater than or equal to 65
                                        [">=",
                                            ["var","padj"],
                                            60
                                        ], 
                                        CLOROTHEME.theme1.blue['60'], // red component if result is greater than or equal to 60
                                        [">=",
                                            ["var","padj"],
                                            55
                                        ], 
                                        CLOROTHEME.theme1.blue['55'], // red component if result is greater than or equal to 55
                                        [">=",
                                            ["var","padj"],
                                            50
                                        ], 
                                        CLOROTHEME.theme1.blue['50'], // red component if result is greater than or equal to 50
                                        [">=",
                                            ["var","padj"],
                                            45
                                        ], 
                                        CLOROTHEME.theme1.blue['45'], // red component if result is greater than or equal to 45
                                        [">=",
                                            ["var","padj"],
                                            40
                                        ], 
                                        CLOROTHEME.theme1.blue['40'], // red component if result is greater than or equal to 40
                                        [">=",
                                            ["var","padj"],
                                            35
                                        ], 
                                        CLOROTHEME.theme1.blue['35'], // red component if result is greater than or equal to 35
                                        [">=",
                                            ["var","padj"],
                                            30
                                        ], 
                                        CLOROTHEME.theme1.blue['35'], // red component if result is greater than or equal to 30
                                        [">=",
                                            ["var","padj"],
                                            25
                                        ], 
                                        CLOROTHEME.theme1.blue['25'], // red component if result is greater than or equal to 25
                                        CLOROTHEME.theme1.blue['25'] // red component if results is less than 25
                                    ]
                                ],
                                ['all',partyStrengthSelected==='Riding Winnery',['!=', ['get', 'Poll Winner'],"null"]],
                                ['rgb', 
                                ["-",255,
                                    ["*",
                                        ["*",
                                            ["/",['get', 'Poll total votes'],['get', 'Electors']],
                                        255],
                                    ]
                                ],
                                ["*",
                                    ["*",
                                        ["/",['get', 'Poll total votes'],['get', 'Electors']],
                                    255],
                                ]
                                ,0],
                                '#424242'
                                
                                ],
                            ]
                        }            
                    },
                    "highway_name_other"
                    );                                              
                }
            }              
        } else {
            if (candidateNameParty == 'Riding Winner') {
                setPartyStrengthSelected('Riding Winner');
            } else {
                setPartyStrengthSelected(partyParty);
            }            

            if (map.current.getSource('testmap-sn')) {
                map.current.removeLayer('sn-layer-poll-shapes');
                map.current.removeLayer('sn-layer-poll-shapes-lines');
                map.current.removeLayer('sn-layer-poll-shapes-lines-z0z13');
                            
                map.current.addLayer({
                    'id': 'sn-layer-riding-shapes',
                    'type': 'fill',
                    'source': 'testmap-sn',
                    'maxzoom': 18,
                    'fill-antialias': false,
                    'filter': [
                        "any",
                        ["!=", "Riding Winner", "???"]
                    ],
                    'paint': {
                        'fill-color':
                            ['case',
                            ['all',isWholeMap,['==', ['get', 'Winner'],'Conservative']],
                            'rgba(9, 94, 230, 1)',
                            ['all',isWholeMap,['==', ['get', 'Winner'],'Progressive Conservative']],
                            'rgba(9, 94, 230, 1)',
                            ['all',isWholeMap,['==', ['get', 'Winner'],'United Conservative']],
                            'rgba(9, 94, 230, 1)',
                            ['all',isWholeMap,['==', ['get', 'Winner'],'Canadian Alliance']],
                            '#5ba963',
                            ['all',isWholeMap,['==', ['get', 'Winner'],'Alberta Party']],
                            '#f8c62e',                            
                            ['all',isWholeMap['==', ['get', 'Winner'],'Wildrose']],
                            '#800080',                            
                            ['all',isWholeMap,['==', ['get', 'Winner'],'Alberta Independence']],
                            '#000000',                            
                            ['all',isWholeMap,['==', ['get', 'Winner'],'Liberal']],     
                            'rgba(230, 9, 9, 1)',
                            ['all',isWholeMap,['==', ['get', 'Winner'],'Ontario Liberal Party']],     
                            'rgba(230, 9, 9, 1)',
                            ['all',isWholeMap,['==', ['get', 'Winner'],'NDP-New Democratic Party']],
                            'rgba(230, 141, 9, 1)',
                            ['all',isWholeMap,['==', ['get', 'Winner'],'NDP']],
                            'rgba(230, 141, 9, 1)',
                            ['all',isWholeMap,['==', ['get', 'Winner'],'N.D.P.']],
                            'rgba(230, 141, 9, 1)',
                            ['all',isWholeMap,['==', ['get', 'Winner'],'Green Party']],
                            'rgba(0, 128, 0, 1)',
                            ['all',isWholeMap,['==', ['get', 'Winner'],'Bloc Québécois']],
                            '#0b9fd6',                    
                            ['all',isWholeMap,['==', ['get', 'Winner'],"People's Party - PPC"]],
                            '#7f0f7e',
                            ['all',isWholeMap,['==', ['get', 'Winner'],"Communist"]],
                            '#c47373',                                                            
                            ['all',isWholeMap,['==', ['get', 'Winner'],"People's Party"]],
                            '#7f0f7e',
                            ['all',isWholeMap,['==', ['get', 'Winner'],"Independent"]],
                            '#424242',
                            ['all',isWholeMap,['==', ['get', 'Winner'],"null"]],
                            '#424242',
                            '#424242'
                            ]
                        ,
                        'fill-opacity': [
                            'case',
                            ['boolean', ['feature-state', 'hover'], false],
                            0.5,
                            0.3
                            ]
                    }            
                });
                map.current.addLayer({
                    'id': 'sn-layer-riding-shapes-lines',
                    'type': 'line',
                    'source': 'testmap-sn',
                    'minzoom': 12,
                    'maxzoom': 24,
                    'filter': [
                        "any",
                        ["!=", "Riding Winner", "???"]
                    ],
                    'paint': {
                        'line-opacity': 0.75,
                        'line-width': 2,
                        'line-color':
                            ['case',
                            ['all',isWholeMap,['==', ['get', 'Winner'],'Conservative']],
                            'rgba(9, 94, 230, 1)',
                            ['all',isWholeMap,['==', ['get', 'Winner'],'Progressive Conservative']],
                            'rgba(9, 94, 230, 1)',
                            ['all',isWholeMap,['==', ['get', 'Winner'],'United Conservative']],
                            'rgba(9, 94, 230, 1)',
                            ['all',isWholeMap,['==', ['get', 'Winner'],'Canadian Alliance']],
                            '#5ba963',
                            ['all',isWholeMap,['==', ['get', 'Winner'],'Alberta Party']],
                            '#f8c62e',
                            ['all',isWholeMap['==', ['get', 'Winner'],'Wildrose']],
                            '#800080',                                                        
                            ['all',isWholeMap,['==', ['get', 'Winner'],'Alberta Independence']],
                            '#000000',                            
                            ['all',isWholeMap,['==', ['get', 'Winner'],'Liberal']],     
                            'rgba(230, 9, 9, 1)',
                            ['all',isWholeMap,['==', ['get', 'Winner'],'Ontario Liberal Party']],     
                            'rgba(230, 9, 9, 1)',
                            ['all',isWholeMap,['==', ['get', 'Winner'],'NDP-New Democratic Party']],
                            'rgba(230, 141, 9, 1)',
                            ['all',isWholeMap,['==', ['get', 'Winner'],'NDP']],
                            'rgba(230, 141, 9, 1)',
                            ['all',isWholeMap,['==', ['get', 'Winner'],'N.D.P.']],
                            'rgba(230, 141, 9, 1)',
                            ['all',isWholeMap,['==', ['get', 'Winner'],'Green Party']],
                            'rgba(0, 128, 0, 1)',
                            ['all',isWholeMap,['==', ['get', 'Winner'],'Bloc Québécois']],
                            '#0b9fd6',                    
                            ['all',isWholeMap,['==', ['get', 'Winner'],"People's Party - PPC"]],
                            '#7f0f7e',
                            ['all',isWholeMap,['==', ['get', 'Winner'],"Communist"]],
                            '#c47373',                                                                                        
                            ['all',isWholeMap,['==', ['get', 'Winner'],"People's Party"]],
                            '#7f0f7e',
                            ['all',isWholeMap,['==', ['get', 'Winner'],"Independent"]],
                            '#424242',
                            ['all',isWholeMap,['==', ['get', 'Winner'],"null"]],
                            '#424242',
                            '#424242'
                            ]
                        
                    }         
                },
                "highway_name_other"
                );
                map.current.addLayer({
                    'id': 'sn-layer-riding-shapes-lines-z0z12',
                    'type': 'line',
                    'source': 'testmap-sn',
                    'minzoom': 0,
                    'maxzoom': 12,
                    'filter': [
                        "any",
                        ["!=", "Riding Winner", "???"]
                    ],
                    'paint': {
                        'line-width': 0.5,
                        'line-opacity': 1,
                        'line-color':
                            ['case',
                            ['all',isWholeMap,['==', ['get', 'Winner'],'Conservative']],
                            'rgba(9, 94, 230, 1)',
                            ['all',isWholeMap,['==', ['get', 'Winner'],'Progressive Conservative']],
                            'rgba(9, 94, 230, 1)',
                            ['all',isWholeMap,['==', ['get', 'Winner'],'United Conservative']],
                            'rgba(9, 94, 230, 1)',                            
                            ['all',isWholeMap,['==', ['get', 'Winner'],'Canadian Alliance']],
                            '#5ba963',
                            ['all',isWholeMap,['==', ['get', 'Winner'],'Alberta Party']],
                            '#f8c62e',
                            ['all',isWholeMap['==', ['get', 'Winner'],'Wildrose']],
                            '#800080',                                                        
                            ['all',isWholeMap,['==', ['get', 'Winner'],'Alberta Independence']],
                            '#000000',                            
                            ['all',isWholeMap,['==', ['get', 'Winner'],'Liberal']],     
                            'rgba(230, 9, 9, 1)',
                            ['all',isWholeMap,['==', ['get', 'Winner'],'Ontario Liberal Party']],     
                            'rgba(230, 9, 9, 1)',
                            ['all',isWholeMap,['==', ['get', 'Winner'],'NDP-New Democratic Party']],
                            'rgba(230, 141, 9, 1)',
                            ['all',isWholeMap,['==', ['get', 'Winner'],'NDP']],
                            'rgba(230, 141, 9, 1)',
                            ['all',isWholeMap,['==', ['get', 'Winner'],'N.D.P.']],
                            'rgba(230, 141, 9, 1)',
                            ['all',isWholeMap,['==', ['get', 'Winner'],'Green Party']],
                            'rgba(0, 128, 0, 1)',
                            ['all',isWholeMap,['==', ['get', 'Winner'],'Bloc Québécois']],
                            '#0b9fd6',                    
                            ['all',isWholeMap,['==', ['get', 'Winner'],"People's Party - PPC"]],
                            '#7f0f7e',
                            ['all',isWholeMap,['==', ['get', 'Winner'],"Communist"]],
                            '#c47373',                                                                                        
                            ['all',isWholeMap,['==', ['get', 'Winner'],"People's Party"]],
                            '#7f0f7e',
                            ['all',isWholeMap,['==', ['get', 'Winner'],"Independent"]],
                            '#424242',
                            ['all',isWholeMap,['==', ['get', 'Winner'],"null"]],
                            '#424242',
                            '#424242'
                            ]
                        
                    }         
                },
                "highway_name_other"
                );                                     
            }             
        }
    }, [candidateNameParty, partyStrengthSelected]);

    return (
        <div>
        <CRow className="align-items-center" style={{marginBottom:'10px'}}>
        <CCol col="12" sm="12" md="12" xl className="mb-3 mb-xl-0">
          {props.data != null ?
          typeof props.data.local_division === 'undefined' ? <></> : 
            <>
              <CButton id="sharetwitter" color="info" onClick={() => { sharetwitter(); }}> <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" className="c-icon mfe-2" role="img"><path d="M31.937 6.093c-1.177 0.516-2.437 0.871-3.765 1.032 1.355-0.813 2.391-2.099 2.885-3.631-1.271 0.74-2.677 1.276-4.172 1.579-1.192-1.276-2.896-2.079-4.787-2.079-3.625 0-6.563 2.937-6.563 6.557 0 0.521 0.063 1.021 0.172 1.495-5.453-0.255-10.287-2.875-13.52-6.833-0.568 0.964-0.891 2.084-0.891 3.303 0 2.281 1.161 4.281 2.916 5.457-1.073-0.031-2.083-0.328-2.968-0.817v0.079c0 3.181 2.26 5.833 5.26 6.437-0.547 0.145-1.131 0.229-1.724 0.229-0.421 0-0.823-0.041-1.224-0.115 0.844 2.604 3.26 4.5 6.14 4.557-2.239 1.755-5.077 2.801-8.135 2.801-0.521 0-1.041-0.025-1.563-0.088 2.917 1.86 6.36 2.948 10.079 2.948 12.067 0 18.661-9.995 18.661-18.651 0-0.276 0-0.557-0.021-0.839 1.287-0.917 2.401-2.079 3.281-3.396z"></path></svg> Share</CButton>
              <CButton id="sharepinterest" style={{marginLeft:'5px'}} color="danger" onClick={() => { sharepinterest(); }}><svg height="100%" className="c-icon" viewBox="0 0 512 512" width="100%" xmlns="http://www.w3.org/2000/svg"><path d="M255.998,0.001c-141.384,0 -255.998,114.617 -255.998,255.998c0,108.456 67.475,201.171 162.707,238.471c-2.24,-20.255 -4.261,-51.405 0.889,-73.518c4.65,-19.978 30.018,-127.248 30.018,-127.248c0,0 -7.659,-15.334 -7.659,-38.008c0,-35.596 20.632,-62.171 46.323,-62.171c21.839,0 32.391,16.399 32.391,36.061c0,21.966 -13.984,54.803 -21.203,85.235c-6.03,25.482 12.779,46.261 37.909,46.261c45.503,0 80.477,-47.976 80.477,-117.229c0,-61.293 -44.045,-104.149 -106.932,-104.149c-72.841,0 -115.597,54.634 -115.597,111.095c0,22.004 8.475,45.596 19.052,58.421c2.09,2.535 2.398,4.758 1.776,7.343c-1.945,8.087 -6.262,25.474 -7.111,29.032c-1.117,4.686 -3.711,5.681 -8.561,3.424c-31.974,-14.884 -51.963,-61.627 -51.963,-99.174c0,-80.755 58.672,-154.915 169.148,-154.915c88.806,0 157.821,63.279 157.821,147.85c0,88.229 -55.629,159.232 -132.842,159.232c-25.94,0 -50.328,-13.476 -58.674,-29.394c0,0 -12.838,48.878 -15.95,60.856c-5.782,22.237 -21.382,50.109 -31.818,67.11c23.955,7.417 49.409,11.416 75.797,11.416c141.389,0 256.003,-114.612 256.003,-256.001c0,-141.381 -114.614,-255.998 -256.003,-255.998Z"></path></svg></CButton>          
            </>
          : <></> }
        </CCol>
      </CRow>        
    <div id="mainmap" className="map-wrap">
        <div ref={mapContainer} className="map">

        {!isWholeMap ? <CModal size="lg" show={modalVisible} onClose={() => setModalVisible(false)}>
      <CModalHeader onClose={() => setModalVisible(false)}>
        <CModalTitle>{pollDetailsTitle}</CModalTitle>
        {mw.length > 0 ? <CBadge className="mr-1 float-right" color="secondary">merge with: {mw}</CBadge> : ""}
      </CModalHeader>
      <CModalBody>{modalContent}</CModalBody>
      <CModalFooter>
        <div style={{fontSize:'8px',fontWeight:'200',position:'absolute',left:'10px'}}>{thePollYear != null ? thePollYear+' ' : ''} {theElectionType === 'Provincial' && props.hasOwnProperty('data') && props.data.hasOwnProperty('minor_jurisdiction') ? provinceShortToLong(props.data.minor_jurisdiction) : ''} {theElectionType != null ? theElectionType+' ' : ''} {theRidingNumber != null ? '- '+theRidingNumber+' ' : ''}</div>
        <CButton color="secondary" onClick={() => setModalVisible(false)}>
          Close
        </CButton>
      </CModalFooter>
    </CModal> : <></> }
    <ControlTranslated theData={props && props.data ? props.data : null} map={map.current} position="top-right">
        {(props && props.data && props.data.minor_jurisdiction !== 'Canada' && props.data.event_type === 'Federal') || (props && props.data && props.data.map_context !== 'Provincial' && props.data.event_type === 'Provincial') ? 
            <GoBroadControl map={map.current} broadControl={() => mapGLToParentLink()} data={{year: mapObj.year, event: mapObj.event, event_type: mapObj.event_type}} /> 
            : <></> 
        }        
    </ControlTranslated>    
    <ControlTranslated theData={props && props.data ? props.data : null} map={map.current} position="top-right">
        {(props && props.data && props.data.minor_jurisdiction !== 'Canada' && props.data.event_type === 'Federal') || (props && props.data && props.data.map_context !== 'Provincial' && props.data.event_type === 'Provincial') ? 
            <PSControl map={map.current} partyPartyChange={setPartyParty} partyStrengthChange={setCandidateNameParty} data={{sortedParty: sortedParty, winner: mapObj ? mapObj.winner : '', selected: partyStrengthSelected, selectedParty: partyParty, cpvOrder: cPVOrder}} /> 
            : <></> 
        }        
    </ControlTranslated>
    <ControlTranslated theData={props && props.data ? props.data : null} map={map.current} position="top-left">
        <ScreenshotControl map={map.current} screenshotcontrol={() => mapScreenshot()} /> 
    </ControlTranslated>    
    
    { graphVisible ? 
    <ControlTranslated theData={props && props.data ? props.data : null} map={map.current} position="bottom-right" style={{width:'100px', height:'100px', aspectRatio:'unset'}}>
    <GraphControl map={map.current} data={graphDataObject} />
    </ControlTranslated>
    : <></> }
    
        </div>
    </div>
    </div>
    );

}

export default MapGL;